export default "__VITE_ASSET__e8a625b1__"